"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageTypeId = exports.PageContextProvider = void 0;
var react_1 = __importStar(require("react"));
var useWebAnalytics_1 = require("../hooks/useWebAnalytics");
var logger_1 = require("../utils/logger");
var PageContext = (0, react_1.createContext)(undefined);
var VISIT_ACTION_TYPE = 'visit';
// eslint-disable-next-line @typescript-eslint/naming-convention
function PageContextProvider(_a) {
    var ids = _a.ids, fields = _a.fields, options = _a.options, children = _a.children;
    var webAnalytics = (0, useWebAnalytics_1.useWebAnalytics)();
    (0, react_1.useEffect)(function () {
        if (webAnalytics && ids.page_type_id) {
            webAnalytics.setPageDefinitions(ids, fields);
        }
        else {
            var errorMessage = "Cannot set page definitions for page ".concat(JSON.stringify(ids, null, 2), ". Please ensure the component is wrapped with WebAnalyticsProvider and the webAnalytics and page_type_id is NOT undefined\n\nFor details on how to fix it, please refer to https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react?ref_type=heads#how-to-fix-cannot-observe-eventelement-for-please-ensure-the-component-is-wrapped-with-webanalyticsprovider-and-the-webanalytics-is-not-undefined-error");
            (0, logger_1.logError)(errorMessage);
        }
    }, [ids, fields]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (webAnalytics && ids.page_type_id) {
            webAnalytics.observe({
                action_type: VISIT_ACTION_TYPE,
                page_type_id: ids.page_type_id,
                event_version: (_a = options === null || options === void 0 ? void 0 : options.eventVersion) !== null && _a !== void 0 ? _a : 1,
            }, {});
        }
    }, [ids.page_type_id]);
    return react_1.default.createElement(PageContext.Provider, { value: ids.page_type_id }, children);
}
exports.PageContextProvider = PageContextProvider;
var usePageTypeId = function () {
    var pageId = (0, react_1.useContext)(PageContext);
    if (!pageId) {
        (0, logger_1.logError)("usePageTypeId must be used within a PageContextProvider\n\nFor details on how to fix it, please refer to https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react#how-to-fix-usepagetypeid-must-be-used-within-a-pagecontextprovider-error\n");
    }
    return pageId;
};
exports.usePageTypeId = usePageTypeId;
